import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const availableModalState = ['none', 'writable'] as const;
export type ModalState = (typeof availableModalState)[number];

type InitialState = {
  modalState: ModalState;
};

const initialState: InitialState = {
  modalState: 'none',
};

export const generatePerformanceSlice = createSlice({
  name: 'generatePerformanceSlice',
  initialState,
  reducers: {
    setGeneratePerformanceModalState: (state, { payload }: PayloadAction<ModalState>) => {
      state.modalState = payload;
    },
    closeGeneratePerformanceModal: (state) => {
      state.modalState = 'none';
    },
  },
  selectors: {
    selectGeneratePerformanceModalState: (state) => state.modalState,
  },
});

export const { closeGeneratePerformanceModal, setGeneratePerformanceModalState } =
  generatePerformanceSlice.actions;
export const { selectGeneratePerformanceModalState } = generatePerformanceSlice.selectors;
